import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormSelect, VpHookFormColorInput } from '../..';
import { useFetchPluginById, useFetchPluginOptions } from '../../../hooks';
import { VpPluginFontFamilySelect } from './VpPluginFontFamilySelect';

import config from '../../../config';

export const VpPluginDateSubmittedInputs = ({ disabled }) => {
  const { data } = useFetchPluginById();
  const { data: optionsData } = useFetchPluginOptions({ enabled: config?.pluginFontSizeEnabled });

  return (
    <Stack direction="row" alignItems="end" spacing={1}>
      <VpPluginFontFamilySelect
        smallLabel
        name="dateFont"
        disableHelperText
        defaultValue={data?.styles?.dateFont}
        disabled={disabled}
        selectDefault
      />
      {config?.pluginFontSizeEnabled && (
        <VpHookFormSelect
          options={optionsData?.descriptionFontSizes}
          required
          name="dateFontSize"
          disableHelperText
          defaultValue={data?.styles?.dateFontSize}
          disabled={disabled}
          selectDefault
        />
      )}
      <VpHookFormColorInput
        required
        name="dateFontColor"
        disableHelperText
        defaultValue={data?.styles.dateFontColor}
        disabled={disabled}
      />
    </Stack>
  );
};

VpPluginDateSubmittedInputs.propTypes = {
  disabled: PropTypes.bool
};

export default VpPluginDateSubmittedInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginDateSubmittedInputs.jsx